import { AVAILABILITY_OPTIONS, SORTING_DIRECTION } from 'src/constants/main';

export interface ICategoriesFilters {
  search: string;
  availability: AVAILABILITY_OPTIONS | undefined;
  sort_field: CATEGORIES_COLUMN_NAME;
  sort_dir: SORTING_DIRECTION;
}

export enum CATEGORIES_COLUMN_NAME {
  NAME = 'name',
  ITEMS = 'items',
  MENU_GROUPS = 'global_categories',
  SORT = 'sort',
}
